import axiosInstance from '../http/axios-instance';
import i18nInstance, { LOCALE_KEY, resolveLanguage } from '../i18n/i18n.config';

/**
 * Primeiro rótulo do host, que identifica o integrador white label. Equivale ao
 * critério do LocaleService do Angular para hosts com domínio.
 */
function integradorContext(): string {
  return window.location.hostname.split('.')[0];
}

function toLocaleId(data: unknown): string | null {
  if (typeof data !== 'object' || data === null) {
    return null;
  }
  const { language, country } = data as { language?: unknown; country?: unknown };
  return typeof language === 'string' && typeof country === 'string'
    ? `${language}_${country}`
    : null;
}

/**
 * Persiste em `localStorage['locale']` o idioma do usuário (ou do integrador) e aplica
 * no i18next. No iframe do Sigma nenhum login do center gravou essa chave, e é dela que
 * a folha Angular e o header `locale` das requisições leem o idioma. Espelha o
 * AppComponent: ausência, falha ou idioma não suportado caem em pt_BR. Nunca lança.
 */
export async function syncDssLocale(): Promise<void> {
  let localeId: string | null = null;
  try {
    const response = await axiosInstance.get<unknown>(
      `public/locale/usuario_or_integrador/${integradorContext()}`,
    );
    localeId = toLocaleId(response.data);
  } catch {
    // Sem idioma do servidor a sessão continua utilizável no idioma padrão.
  }

  const resolved = resolveLanguage(localeId);
  try {
    localStorage.setItem(LOCALE_KEY, resolved);
  } catch {
    // Storage bloqueado no iframe: a folha cai no idioma padrão registrado no bootstrap.
  }
  if (i18nInstance.language !== resolved) {
    void i18nInstance.changeLanguage(resolved);
  }
}
